// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4209":"99dff959","7070":"c980bd0d","9086":"07a3390a"}[chunkId] + ".css";
};